import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeRaw from 'rehype-raw';

export default function MarkdownParser({ content, className }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkRehype]}
      rehypePlugins={[rehypeRaw]}
      className={`relative break-words markdown ${className}`}>
      {content}
    </ReactMarkdown>
  );
}

MarkdownParser.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

MarkdownParser.defaultProps = {
  className: '',
};
